import { Typography } from "@mui/material";
import { useContext } from "react";
import LanguageText from "../Layout/Contexts/LanguageTextContext";

export const translate = (translations, inputText) => {
    let textParts = [];
    if (!!inputText) {        
        textParts = inputText.toString().split(" ");
    } else {
        textParts = [];
    }

    let text = "";
    for (var i = 0; i < textParts.length; i++) {
        const textPart = textParts[i];
        if (textPart.startsWith("i18n_")) {
            const translatedText = translations[textPart.toLowerCase()];
            if (!translatedText) {
                console.log("TODO: add to translations: " + textPart.toLowerCase());
                text = text + " " + textPart;
            } else {
                text = text + " " + translatedText;
            }
        } else {
            text = text + " " + textPart;
        }
    }
    return text;
}

const Text = (props) => {
    const translations = useContext(LanguageText);
    
    // Destructure isPreTranslated en haal het uit de rest van de props
    const { isPreTranslated, text, ...typographyProps } = props;
    
    if (isPreTranslated) {
        return <Typography {...typographyProps} >{text}</Typography>
    }        
    
    const translatedText = translate(translations, text)
    return <Typography {...typographyProps} >{translatedText}</Typography>
}

export default Text;

